var _path, _path2, _path3, _ellipse, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14v2.627a4.141 4.141 0 01-3.824 4.129 41.425 41.425 0 01-6.352 0A4.141 4.141 0 015 14.626V12z",
    fill: "#0B0B0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.037 6.68l-7.515 2.6c-.874.303-.905 1.527-.048 1.873l7.28 2.94a6 6 0 004.493 0l7.279-2.94c.857-.346.826-1.57-.048-1.872l-7.515-2.602a6 6 0 00-3.926 0z",
    fill: "#777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.235l-6 2.47v3.53",
    stroke: "#FFD542",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 10.235,
    rx: 1.412,
    ry: 0.706,
    fill: "#0B0B0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17a1 1 0 112 0v2a1 1 0 11-2 0v-2z",
    fill: "#FFD542"
  })));
}
export default SvgStudent;